module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0077.jpg?v=ae90b527";